import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import tenantsService from 'src/services/tenantService';
import userInfo from 'src/services/userInfo';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	img: {
		width: '100%'
	}
}))

function Logo({ size, ...props }) {
	const classes = useStyles();
	const isMountedRef = useIsMountedRef();
	const [logo, setLogo] = useState(null);
	const account = useSelector(state => state.account);

	// to do: controlla questa parte e usa anche per il cobranding forse
	const hasBpartner = !!account?.user?.extensions?.profiles?.some(p => p.bpartnerId);

	const getLogo = useCallback(() => {
		if (props?.src) return;

		if (hasBpartner) {
			userInfo.getLogoAziendale().then(r => {
				if (isMountedRef.current) setLogo(r || null);
				if (!r && isMountedRef.current) {
					tenantsService.getLogo(size).then(fallback => {
						if (isMountedRef.current) setLogo(fallback);
					});
				}
			});
		} else {
			tenantsService.getLogo(size).then(r => {
				if (isMountedRef.current) setLogo(r);
			});
		}
	}, [hasBpartner, isMountedRef, size])

	useEffect(() => {
		getLogo();
	}, [getLogo])

	if (!logo && !props?.src) return null;

	return (
		<img
			alt="Logo"
			src={logo}
			className={classes.img}
			{...props}
		/>
	);
}

export default Logo;
